module.exports = __webpack_public_path__ + "img/asset-verteilung.1bdf0081.svg";